import { useState } from "react";
import { FunnelSimple, X, ArrowsClockwise } from "@phosphor-icons/react";
import { brDate } from "./util";

function hojeCuiaba() {
  const d = new Date(Date.now() - 4 * 3600 * 1000);
  return d.toISOString().slice(0, 10);
}

function presets(dataVirada) {
  const hoje = hojeCuiaba();
  const [y, m] = hoje.split("-").map(Number);
  const inicioMes = `${y}-${String(m).padStart(2, "0")}-01`;
  const mesAnt = new Date(y, m - 2, 1);
  const fimAnt = new Date(y, m - 1, 0);
  const iso = (d) => d.toISOString().slice(0, 10);
  const dias = (n) => iso(new Date(Date.now() - 4 * 3600 * 1000 - n * 86400000));
  return [
    { id: "mes", label: "Mês atual", inicio: inicioMes, fim: hoje },
    { id: "7d", label: "7 dias", inicio: dias(6), fim: hoje },
    { id: "30d", label: "30 dias", inicio: dias(29), fim: hoje },
    { id: "mes_ant", label: "Mês anterior", inicio: iso(mesAnt), fim: iso(fimAnt) },
    { id: "ano", label: "Ano", inicio: `${y}-01-01`, fim: hoje },
    ...(dataVirada ? [{ id: "pos_virada", label: "Desde a virada", inicio: dataVirada, fim: hoje }] : []),
  ];
}

export default function FiltrosDashboard({ filtros, opcoes, contexto, onChange, onLimpar, onRefresh, loading }) {
  const [aberto, setAberto] = useState(false);
  const ps = presets(contexto?.data_virada);
  const presetAtivo = ps.find((p) => p.inicio === filtros.inicio && p.fim === filtros.fim)?.id;
  const contratosSel = (filtros.contrato_ids || []).map((id) => opcoes.contratos.find((c) => c.id === id)).filter(Boolean);
  const empresaSel = opcoes.empresas.find((e) => e.id === filtros.empresa_id);
  const padrao = filtros.padrao || {};
  const ehPadrao = filtros.inicio === padrao.inicio && filtros.fim === padrao.fim && !filtros.empresa_id &&
    JSON.stringify([...(filtros.contrato_ids || [])].sort()) === JSON.stringify([...(padrao.contrato_ids || [])].sort());

  const toggleContrato = (id) => {
    const cur = filtros.contrato_ids || [];
    onChange({ contrato_ids: cur.includes(id) ? cur.filter((c) => c !== id) : [...cur, id] });
  };

  const painel = (
    <div className="dash-filtros-painel" data-testid="dash-filtros-painel">
      <div className="dash-filtro-grupo">
        <div className="label">Período</div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {ps.map((p) => (
            <button key={p.id} type="button" className="chip-btn" data-active={presetAtivo === p.id} data-testid={`dash-preset-${p.id}`}
              onClick={() => onChange({ inicio: p.inicio, fim: p.fim })}>{p.label}</button>
          ))}
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "center" }}>
          <input type="date" className="input" value={filtros.inicio || ""} max={filtros.fim} data-testid="dash-filtro-inicio"
            onChange={(e) => e.target.value && onChange({ inicio: e.target.value })} style={{ height: 36, fontSize: "0.85rem" }} />
          <span style={{ color: "#71717A" }}>até</span>
          <input type="date" className="input" value={filtros.fim || ""} min={filtros.inicio} data-testid="dash-filtro-fim"
            onChange={(e) => e.target.value && onChange({ fim: e.target.value })} style={{ height: 36, fontSize: "0.85rem" }} />
        </div>
      </div>
      <div className="dash-filtro-grupo">
        <div className="label">Contrato <span style={{ fontWeight: 400, color: "#71717A" }}>(vários)</span></div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", maxHeight: 120, overflowY: "auto" }}>
          <button type="button" className="chip-btn" data-active={!(filtros.contrato_ids || []).length} data-testid="dash-contrato-todos"
            onClick={() => onChange({ contrato_ids: [] })}>Todos</button>
          {opcoes.contratos.map((c) => (
            <button key={c.id} type="button" className="chip-btn" data-active={(filtros.contrato_ids || []).includes(c.id)}
              data-testid={`dash-contrato-${c.id}`} onClick={() => toggleContrato(c.id)} title={c.contratante}>
              {c.numero}{c.status === "Orçamento" ? " (orç.)" : ""} · {(c.contratante || "").slice(0, 22)}
            </button>
          ))}
        </div>
      </div>
      <div className="dash-filtro-grupo">
        <div className="label">Empresa executora</div>
        <select className="select" value={filtros.empresa_id || ""} data-testid="dash-filtro-empresa" style={{ height: 36, fontSize: "0.85rem" }}
          onChange={(e) => onChange({ empresa_id: e.target.value || null })}>
          <option value="">Todas</option>
          {opcoes.empresas.map((e) => <option key={e.id} value={e.id}>{e.nome}</option>)}
        </select>
        {opcoes.empresas.length === 0 && <div style={{ fontSize: "0.72rem", color: "#A1A1AA", marginTop: 4 }}>Nenhuma empresa cadastrada.</div>}
      </div>
    </div>
  );

  return (
    <div className="dash-filtros" data-testid="dash-filtros">
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <button type="button" className="btn btn-ghost btn-sm dash-filtro-toggle" onClick={() => setAberto(!aberto)} data-testid="dash-filtrar-btn" aria-expanded={aberto}>
          <FunnelSimple size={16} weight="bold" /> Filtrar
        </button>
        <div className="dash-filtros-ativos" data-testid="dash-filtros-ativos">
          <span className="chip" data-testid="dash-chip-periodo">Período: {brDate(filtros.inicio)} – {brDate(filtros.fim)}</span>
          {contratosSel.length === 0 ? (
            <span className="chip" data-testid="dash-chip-contrato-todos">Contratos: todos</span>
          ) : contratosSel.map((c) => (
            <span key={c.id} className="chip chip-ativo" data-testid={`dash-chip-contrato-${c.id}`}>
              Contrato {c.numero} <button type="button" onClick={() => toggleContrato(c.id)} aria-label="remover" style={{ marginLeft: 4, lineHeight: 0 }}><X size={10} weight="bold" /></button>
            </span>
          ))}
          {empresaSel && (
            <span className="chip chip-ativo" data-testid="dash-chip-empresa">
              Empresa: {empresaSel.nome} <button type="button" onClick={() => onChange({ empresa_id: null })} aria-label="remover" style={{ marginLeft: 4, lineHeight: 0 }}><X size={10} weight="bold" /></button>
            </span>
          )}
          {!ehPadrao && (
            <button type="button" className="btn btn-ghost btn-sm" onClick={onLimpar} data-testid="dash-limpar-filtros" style={{ color: "#DC2626" }}>
              <X size={14} weight="bold" /> Limpar filtros
            </button>
          )}
          <button type="button" className="btn btn-ghost btn-sm" onClick={onRefresh} data-testid="dash-atualizar" disabled={loading} aria-label="atualizar">
            <ArrowsClockwise size={14} weight="bold" className={loading ? "spin" : ""} />
          </button>
        </div>
      </div>
      {aberto && painel}
    </div>
  );
}
